// extracted by mini-css-extract-plugin
export default {"header":"O9KKu","scroller":"vOqxg","item":"s2_Nq","item_icon":"WpM3B","item_link":"Oo1u7"};